const createMiddleware = errorHandler => () => next => (action) => {
  try {
    next(action);
    if (action.error) {
      errorHandler(action.error);
    }
  } catch (error) {
    errorHandler(error);
  }
};

export default createMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/errorHandler.js